const noopCloseRequested = () => undefined;
export const tooltipFlyoutDefaults = {
  hasArrow: true,
  offset: {
    distance: 8
  },
  onCloseRequested: noopCloseRequested
};
export const ANIMATION_DURATION = 500;
//# sourceMappingURL=tooltipConstants.js.map